// Helpers for detecting/embedding video sources (YouTube, Vimeo, direct MP4, GridFS)

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || "";

export function getVideoEmbed(url) {
  if (!url) return null;

  // Backend-uploaded video (GridFS stream URL, relative path)
  if (url.startsWith("/api/media/file/")) {
    return { kind: "video", src: `${BACKEND_URL}${url}` };
  }

  // YouTube: youtube.com/watch?v=, youtu.be/, youtube.com/shorts/, youtube.com/embed/
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{11})/);
  if (yt) {
    return { kind: "iframe", src: `https://www.youtube.com/embed/${yt[1]}?rel=0` };
  }

  // Vimeo
  const vim = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vim) {
    return { kind: "iframe", src: `https://player.vimeo.com/video/${vim[1]}` };
  }

  // Direct video file
  if (/\.(mp4|webm|ogg|mov)($|\?)/i.test(url)) {
    return { kind: "video", src: url };
  }

  return { kind: "link", src: url };
}

export function getYouTubeThumb(url) {
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|shorts\/|embed\/)|youtu\.be\/)([\w-]{11})/);
  return yt ? `https://img.youtube.com/vi/${yt[1]}/hqdefault.jpg` : null;
}
